// src/Signup.js
import React from 'react';
import { Amplify } from 'aws-amplify';
import { useAuth } from 'react-oidc-context';
import awsExports from './aws-exports.js';
import LogoLink from './LogoLink.jsx';
import './signup.css';

Amplify.configure(awsExports);

function Signup() {
  const auth = useAuth();

  // signinRedirect() sends `state` and a PKCE challenge; react-oidc-context
  // ignores a callback without `state`, so a hand-built Hosted UI URL left
  // users signed out on /members and the guard bounced them back here.
  // The Hosted UI sign-in page carries the "Sign up" link.
  const handleAccess = () => {
    auth.signinRedirect();
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        <LogoLink className="logo-link--card" />
        <div className="signup-header">
          <h1>Access Tickrtrends</h1>
          <p className="signup-subtitle">
            Sign up or log in using our secure authentication system to access curated,
            data-driven S&P 500 stock valuations.
          </p>
        </div>

        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon">🔒</div>
            <h3>Secure Access</h3>
            <p>OAuth-based authentication for your protection</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">📊</div>
            <h3>Weekly Updates</h3>
            <p>Fresh data delivered every week</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">🎉</div>
            <h3>30-Day Free Trial</h3>
            <p>Try risk-free, then $4.99/month</p>
          </div>
        </div>

        <button
          onClick={handleAccess}
          className="signup-button"
        >
          Sign In | Sign Up
        </button>

        <p className="signup-footer">
          By continuing, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
}

export default Signup;